/**
 * Font size tokens for typography hierarchy
 *
 * Note: Ant Design's Typography.Title levels map roughly to:
 *   level={2} ≈ heading, level={3} ≈ subheading, level={4} ≈ emphasis
 */
export const fontSize = {
  /** Status badges, tags, timestamps, fine print */
  badge: "0.75rem", // 12px

  /** Helper text, secondary info, mobile body text */
  caption: "0.85rem", // ~14px

  /** Standard paragraph text, form labels */
  body: "1rem", // 16px

  /** Lead paragraphs, highlighted body text */
  emphasis: "1.1rem", // ~18px

  /** Card titles, section headers, large icons */
  subheading: "1.5rem", // 24px

  /** Page section titles, modal headers */
  heading: "2rem", // 32px

  /** Hero sections, main page titles, large icons */
  display: "2.5rem", // 40px
} as const;

export type FontSizeToken = keyof typeof fontSize;
